import type { SVGProps } from "react";
import {
  FacebookColor,
  InstagramColor,
  PinterestColor,
  TiktokColor,
  TwitterColor,
  YoutubeColor
} from "components/SVG";

export type PropsIconsObject = {
  href?: string;
  shareHref?: string;
  ShareIcon: React.FC<SVGProps<SVGSVGElement>>;
};

type IconsObject = {
  [name: string]: PropsIconsObject;
};

export const iconsObject: IconsObject = {
  facebook: {
    shareHref: `https://www.facebook.com/sharer/sharer.php?u=`,
    href: `http://www.facebook.com/beautypieofficial`,
    ShareIcon: FacebookColor
  },
  instagram: {
    href: `https://www.instagram.com/beautypie`,
    ShareIcon: InstagramColor
  },
  youtube: {
    href: `https://www.youtube.com/channel/UC9f3oNheJuzjPkFE2a24bDA`,
    ShareIcon: YoutubeColor
  },
  twitter: {
    shareHref: `https://twitter.com/intent/tweet?url=`,
    href: `https://twitter.com/beautypie`,
    ShareIcon: TwitterColor
  },
  pinterest: {
    shareHref: `https://pinterest.com/pin/create/button/?url=`,
    href: `https://uk.pinterest.com/beautypie/`,
    ShareIcon: PinterestColor
  },
  tiktok: {
    shareHref: `https://pinterest.com/pin/create/button/?url=`,
    href: `https://www.tiktok.com/@beautypie`,
    ShareIcon: TiktokColor
  }
};
